import Option from "./Option";
import { MAIN_PAGE } from "../../../data/texts";

const AppDownload = () => {
  const { desc, options } = MAIN_PAGE.appDownload;

  return (
    <section className="">
      <div
        className="
        relative
        overflow-hidden
        rounded-[32px] /* کمی گردتر برای حس مدرن‌تر */
        bg-[#120216] /* پس‌زمینه بسیار عمیق و تیره برای تضاد با بنفش */
        border border-white/10
        px-6
        py-10
        md:py-10
        md:px-12
        lg:px-16
        shadow-2xl
        "
      >
        {/* پس‌زمینه گرادیانت ملایم - استفاده از رنگ اصلی شما با شفافیت کم */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#B00EB1]/15 via-transparent to-transparent pointer-events-none" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-[#B00EB1]/10 via-transparent to-transparent pointer-events-none" />

        {/* Glow Effects - پخش کردن نور بنفش در گوشه‌ها */}
        <div className="absolute -top-24 -left-24 w-80 h-80 bg-[#B00EB1]/20 rounded-full blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-[#B00EB1]/15 rounded-full blur-[120px]" />

        <div className="relative z-10 flex flex-col items-center text-center">
          {/* Title + Badge */}
          <div className="mb-2 lg:mb-3">
            <h2
              className="
                text-2xl
                md:text-3xl
                font-black
                text-white
                leading-tight
                tracking-tight
              "
            >
              اپلیکیشن
              <span className="text-[#B00EB1] drop-shadow-[0_0_15px_rgba(176,14,177,0.5)]">
                {" "}
                مدیزن{" "}
              </span>
              در راه است‌‌‌‌‌
              <span className="pr-0.5">...</span>
            </h2>
          </div>

          {/* Description */}
          <p
            className="
              max-w-4xl
              text-sm
              md:text-base
              leading-relaxed
              text-white/60
              lg:text-white/55
              font-light
            "
          >
            {desc}
          </p>

          {/* Options Container */}
          <div
            className="
              mt-6
              grid
              grid-cols-1
              md:grid-cols-3
              gap-4
              w-full
              max-w-4xl
            "
          >
            {options.map((option, index) => (
              <Option key={index} text={option} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownload;
